module.exports = __webpack_public_path__ + "img/xt3@2x.d63b00e2.png";